import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelBrandInfoAction } from '../../modules/common/brandModule';
import { setActiveBrandCateIdAction } from '../../modules/common/cateModule';
import esApplyReducer, { EsApplyInfoDao, setEsApplyInfoAction, setEsApplyProdAction, setEsApplyProdDelAllAction } from '../../modules/es/esApplyModule';
import BrandItem from './button/BrandItem';
import TagBtn from './button/TagBtn';
import NormalSmallBtn from './button/NormalSmallBtn';
import CustomTitle from './title/CustomTitle';
import CustomImg from './image/CustomImg';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from './popup/NormalPopup';

const BrandItemListBlock = styled.div`
`;

const BrandItemListUlBlock = styled.ul`
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

/**
 * 브랜드 아이템 컨트롤러 
 * 
 */
const BrandItemList = ({ evtHandler, loading }) => {

    const dispatch = useDispatch();

    // const [isShowBtm, setShowBtm] = useState(false);
    const [curBrandInfo, setCurBrandInfo] = useState({
        id: 0,
        brnd_han: '', brnd_logo_url: '', brnd_thumb_url: '', brnd_desc: ''
    });
    const [tmpBrandInfo, setTmpBrandInfo] = useState({
        id: 0,
        brnd_han: '', brnd_logo_url: '', brnd_thumb_url: '', brnd_desc: ''
    })
    const [checkedCateId, setCheckedCateId] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [openModal, setOpenModal] = useState(false);


    const { cateItems, brandCateIds,
        activeBrandCateIds, brandItems,
        esApplyInfo, esApplyProdList } = useSelector(
            ({ cateItemsReducer, brandItemsReducer, esApplyReducer }) => ({
                cateItems: cateItemsReducer.cateItems,
                brandCateIds: cateItemsReducer.brandCateIds,
                activeBrandCateIds: cateItemsReducer.activeBrandCateIds,
                brandItems: brandItemsReducer.brandItems,
                esApplyInfo: esApplyReducer.esApplyInfo,
                esApplyProdList: esApplyReducer.esApplyProdList
            })
        );

    useEffect(() => {
        if (activeBrandCateIds !== null &&
            activeBrandCateIds.length > 0) {
            setAllChecked((activeBrandCateIds.length === brandCateIds.length));
            setCheckedCateId(activeBrandCateIds);
            if (brandItems != null && brandItems.length > 0) {
                setCurBrandInfo(brandItems[0]);
                dispatch(setSelBrandInfoAction(brandItems[0]));
                updateEsApplyBrand(brandItems[0].brnd_cd);
            } else {
                setCurBrandInfo({
                    id: 0,
                    brnd_han: '', brnd_logo_url: '', brnd_thumb_url: '', brnd_desc: ''
                });
                dispatch(setSelBrandInfoAction({
                    id: 0,
                    brnd_han: '', brnd_logo_url: '', brnd_thumb_url: '', brnd_desc: ''
                }));
                updateEsApplyBrand('');
            }

        }
    }, [brandItems]);

    const updateEsApplyBrand = (value) => {
        // [SAVE REDUX START]
        // console.log("updateEsApplyBrand --->" + value)
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.brnd_cd = value;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]
    }

    // 브랜드 Name Click 처리 
    const handleBrandClick = (brandItem) => {

        // 선택된 상품이 있으면 상품 삭제 팝업 표시 
        if (esApplyProdList.length > 0) {
            setTmpBrandInfo(brandItem);
            setOpenModal(true);
        } else {
            updateEsApplyBrand(brandItems[0].brnd_cd);
            // update for state
            setCurBrandInfo(brandItem);
            // // update for redux
            dispatch(setSelBrandInfoAction(brandItem));
        }
    }


    // Active 상태 확인
    const checkActive = (cateId) => {
        if (checkedCateId === null || checkedCateId.length === 0) {
            return false;
        } else {
            return (checkedCateId.indexOf(cateId) !== -1);
        }
    }

    // Category Click 처리 
    const handleScndCateClick = (cateId) => {

        let activeBrandCateIds = [...checkedCateId];
        // Check 처리 된 항목의 경우 삭제 하여 비체크 처리 
        if (checkActive(cateId)) {

            if (activeBrandCateIds.length <= 1) {
                return
            }

            const searchIdx = activeBrandCateIds.indexOf(cateId);
            activeBrandCateIds.splice(searchIdx, 1);
        } else {
            // 추가 
            activeBrandCateIds.push(cateId);
            setCheckedCateId([...activeBrandCateIds, cateId]);
        }

        setCheckedCateId(activeBrandCateIds);

        dispatch(setActiveBrandCateIdAction(activeBrandCateIds));

        // check count 와 전체 카운트가 같으면 All Check
        setAllChecked((activeBrandCateIds.length === brandCateIds.length));
    }

    // 전체 선택한 경우 
    const handleAllCheckClick = () => {

        // 전체 선택된 상태의 경우 반응하지 않음
        if (!allChecked) {
            setCheckedCateId(brandCateIds);
            dispatch(setActiveBrandCateIdAction(brandCateIds));
        }
    }

    // 브랜드 랜덤 선택 처리 
    const handleRandomBrandClick = () => {
        let randomIndex = Math.floor(Math.random() * brandItems.length);
        setCurBrandInfo(brandItems[randomIndex]);
        updateEsApplyBrand(brandItems[randomIndex].brnd_cd);
    }

    // 선택된 카테고리 Element 만들기 
    const makeSelectedCateList = () => {

        // console.log("makeSelectedCateList : " + JSON.stringify(selectedCateItems));
        const secondCateRender = brandCateIds.map((selCateId) => {
            let cateName = '';

            // 1 Depth 카테고리 아이디 
            const curCateId = Math.floor(selCateId / 100);
            // 1 Depth 카테고리 정보 가져오기 
            const targetCategory = cateItems.filter(function (item) {
                return item.id === curCateId
            });
            // 2 Depth 카테고리 가져오기 
            const scndCategory = targetCategory[0].cate2;

            // 카테고리 이름 저장 
            scndCategory.some(element => {
                if (element.id === selCateId % 100) {
                    cateName = element.cate_name;
                }
                return (element.id === selCateId % 100);
            });

            return (
                <TagBtn active={checkActive(selCateId)}
                    float='left' onClick={handleScndCateClick}
                    onDelClick={handleScndCateClick}
                    text={cateName} isSmall={true} value={selCateId}
                    width='23%' />
            )

        })

        return secondCateRender;
    }

    // 다음 버튼 선택 처리
    const handleNextBtnClick = () => {
        evtHandler(true);
    }

    // 이전 버튼 선택 처리
    const handlePrevBtnClick = () => {
        evtHandler(false);
    }

    // [START] Modal Popup -------------------- 
    // 모달 닫기 
    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 모달 첫번째 버튼 처리 
    const handleModalBtn1Click = () => {

        // console.log('tempBrandInfo : ' + JSON.stringify(tmpBrandInfo))
        // 상품 삭제 
        dispatch(setEsApplyProdDelAllAction());

        // 브랜드 이름 업데이트 
        updateEsApplyBrand(tmpBrandInfo);
        // update for state
        setCurBrandInfo(tmpBrandInfo);
        // update for redux
        dispatch(setSelBrandInfoAction(tmpBrandInfo));

        // 브랜드 변경 
        setOpenModal(false);
    }

    // 모달 두번째 버튼 처리 
    const handleModalBtn2Click = () => {
        handleModalClose();
    }
    // [END] Modal Popup -------------------- 


    const getBrandList = () => {

        return (
            <BrandItemListUlBlock>
                {
                    brandItems.map((item) => {
                        return (<BrandItem key={item.id}
                            active={(curBrandInfo.id === item.id)}
                            onClick={handleBrandClick}
                            value={item}
                            text={item.brnd_han} />)
                    })
                }
            </BrandItemListUlBlock>
        )

    }

    if (loading) {
        return (<BrandItemListBlock>
            {/* <CustomImg width='270px' height='158px' marginTop="10px"
                img_src='/assets/images/common/empty-cart.png' /> */}
            <CustomTitle title="* 브랜드 정보를 읽어 오고 있는 중입니다."
                textColor="#fc1c67" marginTop="40px" fontWeight="500" fontSize="12px" textAlign='center'
                marginBottom="20px" />
        </BrandItemListBlock>)
    }

    // 브랜드 리스트 표시 하지 않음 
    if (brandItems === null || brandItems.length === 0) {
        return (<BrandItemListBlock>
            {/* <CustomImg width='270px' height='158px' marginTop="10px"
                img_src='/assets/images/common/empty-cart.png' /> */}
            <CustomTitle title="* 선택하신 카테고리를 모두 포함한 브랜드가 없습니다. 카테고리를 다시 선택해 주세요."
                textColor="#fc1c67" marginTop="40px" fontWeight="500" fontSize="12px" textAlign='center'
                marginBottom="20px" />
        </BrandItemListBlock>)
    }

    // 브랜드 리스트 표시 
    return (
        <BrandItemListBlock>
            <div className="aa-top">
                <div className="tag_s-box tf-list small clearfix">
                    <TagBtn active={allChecked}
                        float='left' onClick={handleAllCheckClick}
                        onDelClick={handleAllCheckClick}
                        text='전체품목' isSmall={true} value=''
                        width='23%' />
                    {
                        (brandItems !== null) ? makeSelectedCateList() : <div />
                    }
                </div>
            </div>
            <div className="aa-btm">
                <div className="brand_select-wrap margin_b-20 clearfix">
                    <div className="bs-brand f-left">
                        <p className="bs-logo margin_b-15">
                            <img src={curBrandInfo.brnd_logo_url} alt="" />
                        </p>
                        <div className="bs-info" style={{ backgroundImage: "url(" + curBrandInfo.brnd_thumb_url + ")" }}>
                            <p className="bs-info_text">
                                {curBrandInfo.brnd_desc}
                            </p>
                            <a href="#" className="bs-info-btn font-mont">BRAND HOME</a>
                        </div>

                    </div>
                    <div className="bs_list-wrap f-right small_scroll">
                        <p className="bs_list-link underline margin_b-20"
                            onClick={() => { handleRandomBrandClick() }}>브랜드 고르기 힘들 땐?</p>
                        {getBrandList()}
                    </div>
                </div>
                <div className="text_center">
                    <button type="button" id="brandApplyPrevBtn" className="s-btn gray-btn" onClick={handlePrevBtnClick}>이전</button>
                    <button type="button" id="brandApplyNextBtn" className="s-btn black-btn margin_l-30" onClick={handleNextBtnClick}>다음</button>
                </div>
            </div>

            <Modal isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopup
                    text="같은브랜드의 상품으로만 "
                    text2="견적 요청이 가능합니다."
                    text3="이전에 추가한 상품이 삭제됩니다."
                    btn1="브랜드 변경" btn2="취소"
                    onClick1={handleModalBtn1Click}
                    onClick2={handleModalBtn2Click} />
            </Modal>

        </BrandItemListBlock>

    );
};

export default BrandItemList;